module.exports = __webpack_public_path__ + "img/Cuota_3x_RGB_verde.f8df1fd0.svg";